import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Payment } from './payment/payment';

@Component({
  selector: 'page-event-catalogs-payment',
  templateUrl: 'event-catalogs-payment.html',
})
export class EventCatalogsPayment {

  client: any;
  event: any;
  user: any;
  dataPayments: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public eventProvider: EventData, public auth: AuthData) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.user = this.params.get('user');
  }

  viewPay(pay) {
    console.log(pay)
    window.open(pay.url, '_blank');
  }

  getKey(index) {
    return (Object.keys(this.user.pendentPayment)[index]).replace('-', '');
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-catalogs-payment/event-catalogs-payment.ts